module.exports = __webpack_public_path__ + "img/crm.a5630eba.svg";